<template>
    <div class="uk-padding" style="background-color: rgb(255, 215, 3)">
        <div class="uk-container">

        </div>
    </div>
</template>

<script>
    export default {
        name: "applyNow"
    }
</script>

<style scoped>

</style>